import { createAsyncThunk } from '@reduxjs/toolkit';
import {  _studyDataUrls } from '@custom/Utils/constants/apiUrls';
import incrementLastNumber from './utils';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

const duplicateStudy = createAsyncThunk('duplicateStudy', async (value:any,{rejectWithValue}) => {

  const newStudyInstanceUID = incrementLastNumber(value)

  try {
    let url = `${_studyDataUrls.duplicate(newStudyInstanceUID)}`
    const pacs_token = getCloudPACSToken();
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${pacs_token}`,
      },
      body : JSON.stringify({
        'StudyInstanceUID' : value
      })
    })
    if(response.status === 200){
      return await response.json()
    }
    else{
      rejectWithValue('Failed to fetch')
    }
  } catch (error) {
    return error;
  }
});

export default duplicateStudy;
